
import { useState } from 'react';
import { UploadMethod, UploadType, VisibilityChoice, UploadSource } from '../contexts/types';

export const useUploadType = () => {
  // New visibility-first flow state
  const [visibilityChoice, setVisibilityChoice] = useState<VisibilityChoice>(null);
  const [sourceChoice, setSourceChoice] = useState<UploadSource>(null);
  
  // Existing state
  const [uploadMethod, setUploadMethod] = useState<UploadMethod>('arxiv');
  const [file, setFile] = useState<File | null>(null);
  
  // Derive uploadType from uploadMethod to keep them in sync
  const uploadType: UploadType = uploadMethod === 'arxiv' ? 'external' : 'file';
  
  // Handler for tab change
  const handleTabChange = (value: string) => {
    if (value === 'file') {
      setUploadMethod('file');
    } else if (value === 'external') {
      setUploadMethod('arxiv');
    }
  };

  return {
    visibilityChoice,
    setVisibilityChoice,
    sourceChoice,
    setSourceChoice,
    uploadMethod,
    setUploadMethod,
    uploadType,
    file,
    setFile,
    handleTabChange
  };
};
